import { QuoteSearchType } from '@lio/rule-engine';
import { QuoteStatus } from '@models/quotes';
import { NonTerminalQuoteStatuses, TerminalQuoteStatusesNotBound } from '@pages/Home/UnderwriterHome/constants';
import { QuoteColumnField } from '@pages/Quotes/QuotesTable/QuoteColumnField.enum';
import { UWHomePageAllTransactionTab } from '@pages/Quotes/QuotesTable/utils/getQuickFilterGroups';

export const getFilterQuoteQueryParam = ({
  currentUserId,
  underwriterId,
}: {
  currentUserId: string;
  underwriterId: string;
}) => ({
  searchText: 'searchText',
  [QuoteColumnField.ProductOffering]: 'offeringId',
  [QuoteColumnField.BusinessClass]: 'productOptionId',
  [QuoteColumnField.ProductLabel]: 'productLabelId',
  [QuoteColumnField.WritingCompany]: 'writingCompanyId',
  [QuoteColumnField.EffectiveDate]: 'effectiveOn',
  [QuoteColumnField.StatusChangeDate]: 'quoteLatestStatusChange.latestStatusChangeDate',
  [QuoteColumnField.ModifiedDate]: 'updatedAt',
  [QuoteColumnField.Underwriter]: 'underwriterId',
  [QuoteColumnField.Brokerage]: 'brokerageId',
  [QuoteColumnField.Producer]: 'brokerageProducerId',
  [QuoteColumnField.TotalPremium]: 'totalPremium',
  [QuoteColumnField.Jurisdiction]: 'jurisdictionId',
  [QuoteColumnField.DuplicateQuotes]: 'hasDuplicateQuotes',
  [QuoteColumnField.CreatedByUser]: 'createdByUserFullName',
  [QuoteColumnField.TransactionType]: 'quoteType',
  [QuoteColumnField.Status]: 'statuses',
  [QuoteColumnField.QuoteOrigin]: 'quoteOriginId',
  [QuoteColumnField.QuoteSource]: 'reportingQuoteSource',
  [QuoteColumnField.UnderwritingActivityType]: 'underwritingActivityTypeId',
  [QuoteColumnField.QuoteType]: (value: any) => {
    // intentionally leaving for existing functionality to flow
    let queryValue = value === 'renewal' ? 'Renewal' : 'NewBusiness';
    return [{ key: 'quoteType', value: queryValue }];
  },
  toggle: (value: string) => {
    switch (value) {
      case UWHomePageAllTransactionTab.ShowImportantFirst:
        // TODO: figure out how to handle this (should affect sorting)
        return [];
      default:
        return [];
    }
  },
  uwTab: (value: string) => {
    switch (value) {
      case UWHomePageAllTransactionTab.All:
        return [
          {
            key: 'statuses',
            value: [...NonTerminalQuoteStatuses, ...TerminalQuoteStatusesNotBound],
          },
        ];
      case UWHomePageAllTransactionTab.MyTransactions:
        return [
          {
            key: 'underwriterId',
            value: [underwriterId],
          },
          {
            key: 'statuses',
            value: NonTerminalQuoteStatuses,
          },
        ];
      case UWHomePageAllTransactionTab.MyActionItems:
        return [
          {
            key: 'searchType',
            value: QuoteSearchType.ActionItems,
          },
        ];
      case UWHomePageAllTransactionTab.Closed:
        return [
          {
            key: 'statuses',
            value: TerminalQuoteStatusesNotBound,
          },
        ];

      case 'watchlist':
        return [{ key: 'watchedByUserId', value: currentUserId }];
      case 'all':
        return [];
      default:
        return [];
    }
  },
  quickFilter: (value: string) => {
    switch (value) {
      case 'watchlist':
        return [{ key: 'watchedByUserId', value: currentUserId }];
      case 'all':
        return [];
      default:
        return [];
    }
  },
  statuses: (value: string) => {
    switch (value) {
      case 'all':
        return [
          {
            key: 'statuses',
            value: NonTerminalQuoteStatuses,
          },
        ];
      case 'incomplete':
        return [
          {
            key: 'statuses',
            value: [QuoteStatus.Rated.queryParam, QuoteStatus.ReadyForRating.queryParam],
          },
        ];
      case 'readyToBind':
        return [{ key: 'statuses', value: [QuoteStatus.ReadyToBind.queryParam, QuoteStatus.Underwritten.queryParam] }];
      case 'referredToUnderwriting':
        return [{ key: 'statuses', value: [QuoteStatus.Referred.queryParam] }];
      case 'favorites':
        return [{ key: 'pinnedByUserId', value: currentUserId }];
      case 'closed':
        return [
          {
            key: 'statuses',
            value: [
              QuoteStatus.Canceled.queryParam,
              QuoteStatus.Expired.queryParam,
              QuoteStatus.Rejected.queryParam,
              QuoteStatus.Declined.queryParam,
            ],
          },
        ];
      default:
        return [
          {
            key: 'statuses',
            value: NonTerminalQuoteStatuses,
          },
        ];
    }
  },
});
